import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M18 4.14a30.5 30.5 0 0 1 4.73-.39.55.55 0 0 1 .37.14.5.5 0 0 1 .15.36V20a.51.51 0 0 1-.5.5C14.46 20.62 12 23.25 12 23.25V6.48S9.55 3.86 1.27 3.75a.55.55 0 0 0-.37.14.5.5 0 0 0-.15.36V20a.51.51 0 0 0 .5.5C9.54 20.62 12 23.25 12 23.25" }),
      createElementVNode("path", { d: "M12 22.76a6 6 0 0 1 1.64-3.45A8.18 8.18 0 0 1 18 16.85V1.24a.46.46 0 0 0-.23-.4.6.6 0 0 0-.49-.06 7.8 7.8 0 0 0-3.64 2.27A6.2 6.2 0 0 0 12 6.48" })
    ], -1)
  ]));
}
const interfaceContentBookOpenPages = { render };
export {
  interfaceContentBookOpenPages as default,
  render
};
//# sourceMappingURL=interface-content-book-open-pages.svg.js.map
